import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgMagicSelection = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.965 7.322a2.46 2.46 0 0 1 3.479 0l1.258 1.253c.96.96.96 2.517 0 3.478q0 0 0 0l-8.225 8.226c-.961.96-2.519.96-3.48 0L5.74 19.026a2.46 2.46 0 0 1 0-3.478h0z"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m12.216 9.07 4.712 4.712M9.767 3.445V3.5M5.05 8.18v.038M17.455 19.34v.038M8.877 7.462v-.057"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgMagicSelection);
export default ForwardRef;
